import React from "react";

const DeleteDataPage: React.FC = () => {
  return (
    <div style={{ background: "#030a14", minHeight: "100vh", color: "#e0f0f0", fontFamily: "'Segoe UI', Arial, sans-serif", lineHeight: 1.7 }}>

      {/* Header */}
      <header style={{
        background: "linear-gradient(135deg, #0a1628, #0f2140)",
        padding: "24px 40px",
        borderBottom: "1px solid rgba(0,229,204,0.15)",
        display: "flex",
        alignItems: "center",
        gap: "16px",
      }}>
        <div style={{
          width: 48, height: 48,
          background: "linear-gradient(135deg, #00ffe0, #00e5cc, #22d97f)",
          borderRadius: 12,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 22, fontWeight: 900, color: "#030a14",
        }}>J</div>
        <div>
          <h1 style={{
            fontSize: 22, fontWeight: 800, margin: 0,
            background: "linear-gradient(135deg, #00ffe0, #22d97f)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          }}>
            JepTags <span style={{ fontSize: 13, color: "rgba(224,240,240,0.4)", WebkitTextFillColor: "rgba(224,240,240,0.4)" }}>by BestSky American, Inc.</span>
          </h1>
        </div>
      </header>

      <div style={{ maxWidth: 860, margin: "48px auto", padding: "0 24px 80px" }}>

        {/* Hero */}
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <div style={{
            display: "inline-block",
            background: "rgba(0,229,204,0.1)", border: "1px solid rgba(0,229,204,0.2)",
            color: "#00e5cc", padding: "6px 16px", borderRadius: 20,
            fontSize: 13, fontWeight: 600, marginBottom: 20,
          }}>🗑️ Data Deletion Request</div>
          <h2 style={{
            fontSize: 36, fontWeight: 800, margin: "0 0 12px",
            background: "linear-gradient(135deg, #00ffe0, #00e5cc, #22d97f)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          }}>Request Your Data Deletion</h2>
          <p style={{ color: "rgba(224,240,240,0.5)", fontSize: 15 }}>
            Last updated: March 2026 &nbsp;·&nbsp; Effective: March 2026
          </p>
        </div>

        {/* Card styles */}
        {[
          {
            icon: "📋", title: "Overview",
            content: (
              <>
                <p style={pStyle}>JepTags ("we", "us", or "our") is operated by BestSky American, Inc. This page explains how you can request deletion of your personal data collected by the JepTags mobile application and website at <strong style={{ color: "#00e5cc" }}>jeptags.com</strong>.</p>
                <p style={pStyle}>All deletion requests are processed promptly and you will receive a confirmation email within 30 days.</p>
              </>
            )
          },
          {
            icon: "📩", title: "How to Submit a Deletion Request",
            content: (
              <>
                <ol style={{ listStyle: "none", padding: 0, counterReset: "steps" }}>
                  {[
                    <>Send an email to <strong style={{ color: "#e0f0f0" }}>info@bestskyamerican.com</strong> from the email address linked to your JepTags account or app usage.</>,
                    <>Use the subject line: <strong style={{ color: "#e0f0f0" }}>"Data Deletion Request — JepTags"</strong></>,
                    <>Include your <strong style={{ color: "#e0f0f0" }}>full name</strong>, <strong style={{ color: "#e0f0f0" }}>device type</strong>, and any account details to help us locate your data.</>,
                    <>We will <strong style={{ color: "#e0f0f0" }}>confirm receipt within 5 business days</strong> and complete full deletion within <strong style={{ color: "#e0f0f0" }}>30 days</strong>.</>,
                  ].map((step, i) => (
                    <li key={i} style={{ ...stepStyle, counterIncrement: "steps" }}>
                      <span style={stepNumStyle}>{i + 1}</span>
                      <span style={{ color: "rgba(224,240,240,0.7)", fontSize: 15 }}>{step}</span>
                    </li>
                  ))}
                </ol>
                <a href="mailto:info@bestskyamerican.com?subject=Data%20Deletion%20Request%20%E2%80%94%20JepTags" style={btnStyle}>
                  ✉️ &nbsp; Email Us to Request Deletion
                </a>
              </>
            )
          },
          {
            icon: "📦", title: "Data We Will Delete",
            content: (
              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Google account email address and display name",
                  "GPS / location data collected during product scans",
                  "Product scan history and authentication records",
                  "Device identifiers and usage analytics",
                  "Loyalty rewards and lottery entries",
                  "Any data stored with third-party services (e.g. Firebase)",
                ].map((item, i) => (
                  <li key={i} style={liStyle}>
                    <span style={liBulletStyle}>✓</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            )
          },
          {
            icon: "⏱️", title: "Data Retention Schedule",
            content: (
              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 8, fontSize: 14 }}>
                <thead>
                  <tr>
                    {["Data Type", "Action", "Timeline"].map(h => (
                      <th key={h} style={{ textAlign: "left", color: "#00e5cc", fontSize: 12, letterSpacing: "0.08em", textTransform: "uppercase", padding: "8px 0", borderBottom: "1px solid rgba(0,229,204,0.15)" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["Google account info (name, email)", "deleted"],
                    ["GPS / location data", "deleted"],
                    ["Product scan history", "deleted"],
                    ["Device identifiers & analytics", "deleted"],
                    ["Firebase / third-party SDK data", "deleted"],
                    ["Transaction / payment records", "retained"],
                  ].map(([label, type], i) => (
                    <tr key={i}>
                      <td style={{ padding: "12px 0", borderBottom: "1px solid rgba(0,229,204,0.06)", color: "#e0f0f0", width: "42%", paddingRight: 12 }}>{label}</td>
                      <td style={{ padding: "12px 0", borderBottom: "1px solid rgba(0,229,204,0.06)" }}>
                        <span style={type === "deleted" ? pillDeletedStyle : pillRetainedStyle}>
                          {type === "deleted" ? "Deleted" : "Retained"}
                        </span>
                      </td>
                      <td style={{ padding: "12px 0", borderBottom: "1px solid rgba(0,229,204,0.06)", color: "rgba(224,240,240,0.7)" }}>
                        {type === "deleted" ? "Within 30 days" : "7 years (legal requirement)"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          },
          {
            icon: "⚠️", title: "Important Notes",
            content: (
              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Deletion requests are permanent and cannot be undone",
                  "Some data may be retained where required by applicable law",
                  "Third-party services (Google, Firebase) will be notified to remove your data where technically possible",
                  "You will receive a confirmation email once deletion is complete",
                  "JepTags does not sell your personal data to any third parties",
                ].map((item, i) => (
                  <li key={i} style={liStyle}>
                    <span style={liBulletStyle}>✓</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            )
          },
        ].map(({ icon, title, content }, i) => (
          <div key={i} style={cardStyle}>
            <h3 style={h3Style}>
              <span style={iconStyle}>{icon}</span>
              {title}
            </h3>
            {content}
          </div>
        ))}

        {/* Contact Card */}
        <div style={contactCardStyle}>
          <h3 style={{ fontSize: 20, fontWeight: 700, color: "#00e5cc", marginBottom: 16 }}>Contact Us</h3>
          <p style={contactPStyle}>If you have questions about your data or this process, please contact us:</p>
          <p style={contactPStyle}><strong style={{ color: "#e0f0f0" }}>BestSky American, Inc.</strong></p>
          <p style={contactPStyle}>930 Rincon Cir, San Jose, CA 95131, United States</p>
          <p style={contactPStyle}>📧 <a href="mailto:info@bestskyamerican.com" style={linkStyle}>info@bestskyamerican.com</a></p>
          <p style={contactPStyle}>🌐 <a href="https://jeptags.com" style={linkStyle}>jeptags.com</a></p>
          <p style={contactPStyle}>📞 <a href="tel:+14083400359" style={linkStyle}>+1 (408) 340-0359</a></p>
        </div>

      </div>

      <footer style={{ textAlign: "center", padding: 24, color: "rgba(224,240,240,0.2)", fontSize: 12, borderTop: "1px solid rgba(0,229,204,0.06)" }}>
        © 2026 BestSky American, Inc. · JepTags · All rights reserved
      </footer>

    </div>
  );
};

// ── Styles ──────────────────────────────────────────────────────────────────
const cardStyle: React.CSSProperties = {
  background: "rgba(15,33,64,0.5)",
  border: "1px solid rgba(0,229,204,0.08)",
  borderRadius: 16, padding: 32, marginBottom: 24,
};
const h3Style: React.CSSProperties = {
  fontSize: 18, fontWeight: 700, color: "#00e5cc",
  marginBottom: 16, display: "flex", alignItems: "center", gap: 10,
};
const iconStyle: React.CSSProperties = {
  width: 32, height: 32, background: "rgba(0,229,204,0.1)",
  borderRadius: 8, display: "inline-flex", alignItems: "center",
  justifyContent: "center", fontSize: 16,
};
const pStyle: React.CSSProperties = { color: "rgba(224,240,240,0.7)", fontSize: 15, marginBottom: 12 };
const liStyle: React.CSSProperties = {
  display: "flex", alignItems: "flex-start", gap: 10,
  color: "rgba(224,240,240,0.7)", fontSize: 15,
  padding: "6px 0",
};
const liBulletStyle: React.CSSProperties = {
  minWidth: 20, height: 20,
  background: "rgba(34,217,127,0.12)",
  border: "1px solid rgba(34,217,127,0.25)",
  color: "#22d97f", borderRadius: 6,
  fontSize: 11, fontWeight: 700,
  display: "inline-flex", alignItems: "center", justifyContent: "center",
  flexShrink: 0, marginTop: 2,
};
const stepStyle: React.CSSProperties = {
  display: "flex", alignItems: "flex-start", gap: 14,
  padding: "10px 0", borderBottom: "1px solid rgba(0,229,204,0.06)",
};
const stepNumStyle: React.CSSProperties = {
  minWidth: 28, height: 28,
  background: "linear-gradient(135deg, #00e5cc, #22d97f)",
  color: "#030a14", borderRadius: 8, fontWeight: 800, fontSize: 13,
  display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
};
const btnStyle: React.CSSProperties = {
  display: "inline-flex", alignItems: "center", gap: 8,
  background: "linear-gradient(135deg, #00e5cc, #22d97f)",
  color: "#030a14", fontWeight: 700, fontSize: 15,
  padding: "13px 28px", borderRadius: 10, textDecoration: "none", marginTop: 20,
};
const pillDeletedStyle: React.CSSProperties = {
  display: "inline-block", padding: "2px 12px", borderRadius: 100,
  fontSize: 12, fontWeight: 600,
  background: "rgba(34,217,127,0.1)", color: "#22d97f",
  border: "1px solid rgba(34,217,127,0.2)",
};
const pillRetainedStyle: React.CSSProperties = {
  display: "inline-block", padding: "2px 12px", borderRadius: 100,
  fontSize: 12, fontWeight: 600,
  background: "rgba(255,100,100,0.08)", color: "#ff8fa3",
  border: "1px solid rgba(255,100,100,0.15)",
};
const contactCardStyle: React.CSSProperties = {
  background: "linear-gradient(135deg, rgba(0,229,204,0.08), rgba(34,217,127,0.05))",
  border: "1px solid rgba(0,229,204,0.2)",
  borderRadius: 16, padding: 32, textAlign: "center", marginTop: 40,
};
const contactPStyle: React.CSSProperties = { color: "rgba(224,240,240,0.6)", marginBottom: 8 };
const linkStyle: React.CSSProperties = { color: "#00e5cc", textDecoration: "none", fontWeight: 600 };

export default DeleteDataPage;
